import React from 'react';
import { Button, Container, Card, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaExclamationTriangle } from 'react-icons/fa';

const NotFound = () => {
  const navigate = useNavigate();

  const primaryColor = '#886b1bff';
  const secondaryColor = '#297e72ff';

  return (
    <div style={{
      backgroundColor: '#f8fafc',
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '2rem'
    }}>
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <Card className="border-0 shadow-sm text-center">
              <Card.Body style={{ padding: '3rem' }}>
                {/* Icon Section */}
                <div style={{
                  width: '120px',
                  height: '120px',
                  backgroundColor: `${primaryColor}20`,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 2rem'
                }}>
                  <FaExclamationTriangle 
                    size={48} 
                    color={primaryColor}
                  />
                </div>

                {/* Error Code */}
                <h1 style={{
                  fontSize: '4rem',
                  color: primaryColor,
                  fontWeight: '700',
                  marginBottom: '1rem'
                }}>
                  404
                </h1>

                {/* Title */}
                <h2 style={{
                  color: '#2d3748',
                  fontWeight: '600',
                  marginBottom: '1rem',
                  fontSize: '1.75rem'
                }}>
                  Page Not Found
                </h2>

                {/* Description */}
                <p style={{
                  color: '#718096',
                  fontSize: '1.1rem',
                  lineHeight: '1.6',
                  marginBottom: '2.5rem'
                }}>
                  The page you're looking for doesn't exist or has been moved. 
                  Please check the URL or navigate back to the dashboard.
                </p>

                {/* Action Buttons */}
                <div className="d-flex gap-3 justify-content-center">
                  <Button
                    variant="primary"
                    onClick={() => navigate(-1)}
                    style={{
                      backgroundColor: secondaryColor,
                      border: 'none',
                      padding: '12px 24px',
                      fontWeight: '500',
                      borderRadius: '8px'
                    }}
                  >
                    <FaArrowLeft className="me-2" />
                    Go Back
                  </Button>
                  
                  <Button
                    variant="outline-primary"
                    onClick={() => navigate('/')}
                    style={{
                      border: `2px solid ${primaryColor}`,
                      color: primaryColor,
                      backgroundColor: 'transparent',
                      padding: '12px 24px',
                      fontWeight: '500',
                      borderRadius: '8px'
                    }}
                  >
                    Go to Dashboard
                  </Button>
                </div>

                {/* Additional Help */}
                <div style={{
                  marginTop: '3rem',
                  padding: '1.5rem',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px',
                  border: '1px solid #e9ecef'
                }}>
                  <h6 style={{ 
                    color: primaryColor, 
                    fontWeight: '600',
                    marginBottom: '0.5rem'
                  }}>
                    Need Help?
                  </h6>
                  <p style={{ 
                    color: '#718096', 
                    margin: 0,
                    fontSize: '0.9rem'
                  }}>
                    If you believe this is an error, please contact the administrator 
                    or check your navigation path.
                  </p>
                </div>
              </Card.Body>
            </Card>

            {/* Footer Note */}
            <div className="text-center mt-4">
              <p style={{ 
                color: '#a0aec0', 
                fontSize: '0.9rem',
                margin: 0
              }}>
                © {new Date().getFullYear()} Your Company Name. All rights reserved.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NotFound;